module.exports = __webpack_public_path__ + "static/media/ios-switch.66ef4803.svg";